import { ca } from '@cian/analytics';

export function trackOpenCommentsBlock() {
  ca('eventSite', {
    action: 'comment_open_main_block',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
